import { BASE_URL, BASE_URL_LEGACY } from "./";

export const accountService = {
  getEnergyDetail,
  setEnergyDetail,
  setAlert,
  setEmail,
};

function getEnergyDetail(user) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/common/settings/?user_id=${user.user_id}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function setEnergyDetail(user_id, values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `user_id=${user_id}&name=${values.name}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/common/settings/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function setAlert(alert_notification) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `alert_notification=${alert_notification}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/common/settings/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}
function setEmail(email_report) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `email_report=${email_report}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/common/settings/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
